import api from './api'

// Ids are typed `number | string` and are interpolated into request URLs, so
// they are encoded first: a value containing '/', '?' or '../' would otherwise
// rewrite the path and hit an unintended endpoint. No-op for numeric ids.
const segment = (id: number | string): string => encodeURIComponent(String(id))

export const projectsApi = {
  getAll: (params: Record<string, any> = {}): Promise<any> => api.get('/projects', { params }),
  getById: (id: number | string): Promise<any> => api.get(`/projects/${segment(id)}`),
  create: (data: Record<string, any>): Promise<any> => api.post('/projects', data),
  update: (id: number | string, data: Record<string, any>): Promise<any> => api.put(`/projects/${segment(id)}`, data),
  delete: (id: number | string): Promise<any> => api.delete(`/projects/${segment(id)}`),
  getForEdit: (id: number | string): Promise<any> => api.get(`/projects/${segment(id)}/edit`),
  getCreateData: (): Promise<any> => api.get('/projects/create'),
}

export default projectsApi

export {
  useGetProjectsQuery,
  useGetProjectQuery,
  useDeleteProjectMutation,
} from '@/redux/api/projectsApi'
